import {OrdersCreateSubjectElementType, OrdersCreateSubjectType, OrdersCreateType} from "../interface";
import moment from "moment";

export const ordersCreateInit: OrdersCreateType = {
    _new_l_address_value: "",
    _new_l_order_type_m_value: "",
    _new_l_recipient_value: "",
    _new_l_vat_value: "",
    address1: "",
    address2: "",
    addressName: "",
    applicationName: "",
    currencyName: "",
    customerMemo: "",
    customerName: "",
    endDt: "",
    endFlag: "",
    endNo: "",
    endState: "",
    enduserName: "",
    industryName: "",
    newDAmount: 0,
    newDExchangeRate: 0,
    newDUnreceivableBond: 0,
    newDtEstimatedCollection: "",
    newDtOrder: moment().format("YYYY-MM-DD"),
    newDtRequestShipment: moment().format("YYYY-MM-DD"),
    newDtShipment: moment().format("YYYY-MM-DD"),
    newLApplicationValue: "",
    newLCustomerValue: "",
    newLEnduserValue: "",
    newLIndustryValue: "",
    newLInvoiceAgentValue: "",
    newLShipToValue: "",
    newName: "",
    newPCurrency: 0,
    newPPayment: 0,
    newPProgress: 100000000,
    newPShipment: 0,
    newPShipmentName: "",
    newShipmentId: "",
    newTxtCollection: "",
    newTxtMemo: "",
    newTxtNote: "",
    newTxtProjectCode: "",
    orderNo: "",
    orderTypeName: "",
    owneridValue: "",
    owningUserName: "",
    paymentName: "",
    progressName: "",
    purchaseOrderId: 0,
    recipientMobilephone: "",
    recipientName: "",
    shipToName: "",
    shipmentNo: "",
    taxCharge: "",
    taxContact: "",
    taxEmail: "",
    taxFlag: "",
    chargeId: 0,
    chargeName: "",
    contactName: "",
    newLContactValue: "",
    salesInvoiceRemark: "",
    vatName: "",
    endType: "1",
    salesType: "1"
};

export const ordersCreateSubjectInit: OrdersCreateSubjectType = {
    list: []
}

export const ordersCreateSubjectElementInit: OrdersCreateSubjectElementType = {
    _new_l_erp_product_value: "",
    _new_l_shipment_value: "",
    currencyName: "",
    newTxtNmItem: "",
    new_d_exchange_rate: 1,
    new_d_total: 0,
    new_d_unitprice: 0,
    new_d_won: 0,
    new_i_qty: 0,
    new_p_currency: "100000000", // KRW. USD : 100000001
    new_shipment_subjectid: "",
    new_txt_standard: "",
    productGroupName: "",
}
